/*
 * -----------------------------------------------------------------------
 *  <copyright file="inactive-icon/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './styles.scss';

const InactiveIcon = () => (
    <span className="icon-wrap inactive-icon">
        <FontAwesomeIcon icon={['fal', 'times-circle']} className="times-circle inactive-cell" />
    </span>
);

export default InactiveIcon;
